import React from 'react';
import styled from 'styled-components';
import { X } from 'lucide-react';
import { FaApple, FaAndroid } from 'react-icons/fa';

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    opacity: ${props => props.$isOpen ? 1 : 0};
    pointer-events: ${props => props.$isOpen ? 'all' : 'none'};
    transition: opacity 0.3s ease;
`;

const ModalContainer = styled.div`
    background: linear-gradient(135deg, #020611 0%, #050B15 50%, #020611 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 2.5rem;
    max-width: 500px;
    width: 90%;
    position: relative;
    transform: ${props => props.$isOpen ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #94A3B8;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #ffffff;
    }
`;

const ModalTitle = styled.h2`
    font-family: Very Sans Headline, Sans Serif;
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 1rem 0;
    text-align: center;
`;

const ModalSubtitle = styled.p`
    color: #94A3B8;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
    text-align: center;
    margin: 0 0 2rem 0;
    line-height: 1.5;
`;

const DownloadOptions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const DownloadButton = styled.button`
    background: ${props => props.$variant === 'android' 
        ? 'linear-gradient(135deg, #3DDC84 0%, #2BB673 100%)' 
        : 'linear-gradient(135deg, #555555 0%, #333333 100%)'};
    color: white;
    border: none;
    padding: 16px 24px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: Very Sans, Sans Serif;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-shadow: 0 4px 15px ${props => props.$variant === 'android' 
        ? 'rgba(61, 220, 132, 0.3)' 
        : 'rgba(0, 0, 0, 0.3)'};
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px ${props => props.$variant === 'android' 
            ? 'rgba(61, 220, 132, 0.4)' 
            : 'rgba(0, 0, 0, 0.4)'};
    }
    
    &:active {
        transform: translateY(0);
    }
`;

const ComingSoonBadge = styled.span`
    background: rgba(255, 255, 255, 0.1);
    color: #94A3B8;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const GetStartedModal = ({ isOpen, onClose }) => {

    const handleDownload = () => {
        window.open(
        "https://play.google.com/store/apps/details?id=com.HydrixApp",
        "_blank",
        'noopener, noreferrer'
        );
    };

    const handleDownloadios = () => {
        window.open(
        "https://apps.apple.com/app/id6753764380",
        "_blank",
        'noopener, noreferrer'
        );
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <ModalOverlay $isOpen={isOpen} onClick={handleOverlayClick}>
            <ModalContainer $isOpen={isOpen}>
                <CloseButton onClick={onClose}>
                    <X size={20} />
                </CloseButton>
                
                <ModalTitle>Get Started with Hydrix</ModalTitle>
                <ModalSubtitle>
                    Download the Hydrix app and start mining cryptocurrency on your mobile device today.
                </ModalSubtitle>
                
                <DownloadOptions>
                    <DownloadButton 
                        $variant="android" 
                        onClick={handleDownload}
                    >
                        <FaAndroid size={24} />
                        Download for Android
                    </DownloadButton>
                    
                    <DownloadButton $variant="ios" onClick={handleDownloadios}>
                        <FaApple size={24} />
                        Download for iOS
                    </DownloadButton>
                </DownloadOptions>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default GetStartedModal;